<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        :rules="rules"
        ref="ruleForm"
      >
        <a-form-model-item label="Cơ quan ban hành" prop="title">
          <a-input
            v-model="form.title"
            placeholder="Nhập cơ quan ban hành..."
          />
        </a-form-model-item>
        <a-form-model-item label="Địa chỉ">
          <a-textarea
            v-model="form.address"
            placeholder="Nhập địa chỉ...."
            :auto-size="{ minRows: 3 }"
          />
        </a-form-model-item>

        <a-form-model-item label="Mô tả">
          <VueEditor
            class="ict24h-editor"
            :editor-toolbar="customToolbar"
            placeholder="Nhập mô tả..."
            v-model="form.description"
          />
        </a-form-model-item>
        <a-form-model-item label="Trạng thái">
          <a-switch
            @change="onChangeStatus"
            checked-children="Đang hoạt động"
            un-checked-children="Ngừng hoạt động"
            :default-checked="form.status === 'ACTIVE' ? true : false"
          />
        </a-form-model-item>
      </a-form-model>
      <a-divider orientation="left">
        THÔNG TIN CẬP NHẬT
      </a-divider>
      <a-descriptions :column="1">
        <a-descriptions-item label="Tạo bởi">
          {{ form.author && (form.author.fullname || form.author.username) }}
        </a-descriptions-item>
        <a-descriptions-item label="Ngày tạo">
          {{ form.createdAt | formatDateHour }}
        </a-descriptions-item>
        <a-descriptions-item label="Cập nhật lần cuối">
          {{ form.updatedAt | formatDateHour }}
        </a-descriptions-item>
      </a-descriptions>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Xác nhận xóa thông tin?"
          ok-text="Có"
          cancel-text="Không"
          @confirm="onDeletedDocumentAgencyIssued"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left;"
            :loading="loadingBtn"
          >
            Xóa
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" @click="close">
          Đóng
        </a-button>
        <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
          Cập nhật
        </a-button>
      </div>
    </div>
  </a-skeleton>
</template>
<script>
import typeBenefits from "@/constants/interface/typeBenefits";
import query from "../constant/query";

const rules = {
  title: [{ required: true, message: "Cơ quan ban hành không được bỏ trống" }],
};
export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    idDocumentAgencyIssued: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      typeBenefits,
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: {},
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
      loadingBtn: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdatedDocumentAgencyIssued();
        } else {
          return false;
        }
      });
    },
    onUpdatedDocumentAgencyIssued() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateDocumentAgencyIssued,
          variables: {
            id: this.form.id,
            title: this.form.title,
            address: this.form.address,
            description: this.form.description,
            status: this.form.status,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Cập nhật cơ quan ban hành thành công!",
          });
          this.loadingBtn = false;
          if (data?.updateDocumentAgencyIssued?.id) {
            this.refreshAfterUpdated(data.updateDocumentAgencyIssued);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Cập nhật cơ quan ban hành không thành công!",
          });
          console.log("Cập nhật cơ quan ban hành không thành công", err);
        });
    },
    onGetDocumentAgencyIssued() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getDocumentAgencyIssued,
          variables: { id: this.idDocumentAgencyIssued },
        })
        .then(({ data }) => {
          this.loading = false;
          if (data?.getDocumentAgencyIssued?.id) {
            this.form = { ...data.getDocumentAgencyIssued };
            this.form = { ...data.getDocumentAgencyIssued };
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Lấy chi tiết cơ quan ban hành không thành công!",
          });
          console.log("Lấy chi tiết cơ quan ban hành không thành công", err);
        });
    },
    onDeletedDocumentAgencyIssued() {
      if (this?.form?.id) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteDocumentAgencyIssued,
            variables: {
              id: this.form.id,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Thông báo",
              description: "Xóa cơ quan ban hành thành công!",
            });
            this.loadingBtn = false;
            if (data?.deleteDocumentAgencyIssued?.id) {
              this.refreshAfterDeleted(data.deleteDocumentAgencyIssued);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Thông báo",
              description: "Xóa cơ quan ban hành không thành công!",
            });
            console.log("Xóa cơ quan ban hành không thành công", err);
          });
      }
    },
    onChangeStatus(check) {
      if (check) {
        this.$set(this.form, "status", "ACTIVE");
      } else {
        this.$set(this.form, "status", "DEACTIVE");
      }
    },
  },
  created() {
    this.onGetDocumentAgencyIssued();
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
